var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-input',{attrs:{"label":_vm.label,"help-text":_vm.helpText,"type":"number"},on:{"change":_vm.handleInput},model:{value:(_vm.filterValue),callback:function ($$v) {_vm.filterValue=$$v},expression:"filterValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }